import { render, staticRenderFns } from "./ExamWithdrawalCard.vue?vue&type=template&id=ca6c4d4e&scoped=true"
import script from "./ExamWithdrawalCard.vue?vue&type=script&lang=js"
export * from "./ExamWithdrawalCard.vue?vue&type=script&lang=js"
import style0 from "./ExamWithdrawalCard.vue?vue&type=style&index=0&id=ca6c4d4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6c4d4e",
  null
  
)

export default component.exports